import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import {createSearchParams} from "react-router-dom";
import LinkPlus from "../../../../components/Link/LinkPlus";
import FeeStudentController from "../../../../services/system/fee-student/fee-student-controller";
import {getSchoolYear} from "../../../../utils/authority";
import GradeManager from "../../../../components/Grade";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../services/system/student/student-controller";
import Utils from "../../../../utils/utils";
registerLocale("vi", vi);
class FeeStudentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentId: -1,
            classRoomId: -1,
            gradeId: "",
            listClassRoom: [],
            listStudent: [],

            name: "",
            state: "ACTIVE",
            listData: [],
            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "fee",
                    name: "Cấu hình học phí áp dụng",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "fee",
                    name: "Học phí",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "fee",
                    name: "Các khoản phí đầu năm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ăn trưa, bán trú",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ăn sáng",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ưu đãi tuyển sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ưu đãi đặc biệt",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Học phí sau ưu đãi",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Loại thanh toán",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Đã thanh toán",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Còn lại",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListFeeStudent()
        this.getListClassRoom()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListFeeStudent();
            }
        );
    };
    getListFeeStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            studentId: this.state.studentId,
            classId: this.state.classRoomId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            state: this.state.state,
            sort: "created_at desc"
        };
        FeeStudentController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListFeeStudent()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "LOCK",
                "name": "Khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListClassByGrade = (gradeId) => {
        let payload = {
            name: "",
            grade: gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            if (res.success){
                this.setState({
                    listClassRoom: res.data.content
                })
            }
        })
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClassByGrade(gradeId)
        })
    }
    getListClassRoom = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: parseInt(this.state.classRoomId),
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 1000,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    render() {
        let {listData, header, gradeId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-fee" parentClass="wallet-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý học phí học sinh"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.state.classRoomId = e.target.value;
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        }, () =>{
                                                            this.getListFeeStudent()
                                                            this.getListStudent()
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Chọn học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            }, ()=>{
                                                                this.getListFeeStudent();
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListStudent()
                                                    }}

                                                />
                                            </div>
                                        </div>
                                        {/*<div className="row">*/}
                                        {/*    <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"*/}
                                        {/*         style={{*/}
                                        {/*             alignItems: "center",*/}
                                        {/*             justifyContent: "right"*/}
                                        {/*         }}>*/}
                                        {/*        <LinkPlus*/}
                                        {/*            style={{color: '#000'}}*/}
                                        {/*            to={{*/}
                                        {/*                pathname: "/ad-sas-school/chi-tiet-hoc-phi-hoc-sinh",*/}
                                        {/*            }}*/}
                                        {/*        >*/}
                                        {/*            <button*/}
                                        {/*                style={{height: 35, marginRight: 12}}*/}
                                        {/*                type="button"*/}
                                        {/*                className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"*/}
                                        {/*            >*/}
                                        {/*                Thêm mới*/}
                                        {/*            </button>*/}
                                        {/*        </LinkPlus>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListFeeStudent()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.studentLiteRes?.fullName}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.studentLiteRes?.currentClassRoomRes?.name}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.detailFeeRes?.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.baseFee)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.startYearMoney)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.eatAndLive)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.eatBreakfast)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.discountAdmission)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.discountSpecial)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.feeAfterDiscount)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.feeAfterDiscount)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.feeAfterDiscount)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.feeAfterDiscount)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/chi-tiet-hoc-phi-hoc-sinh",
                                                                        search: createSearchParams({
                                                                            feeId: `${row.detailFeeRes?.id}`,
                                                                            studentId: `${row.studentLiteRes?.id}`,
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            feeId: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-book"/>
                                                                    </button>
                                                                </LinkPlus>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FeeStudentManagement;
